export default "__VITE_ASSET__CwaW4eD0__";